export default function dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        mimeNew = mime.split("/").pop(),
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    const data = new File([u8arr], filename + "." + mimeNew, { type: mime });
    return { data, dataurl };
}
